import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

const GetDeterminedAvailabilityFragment = graphql(/* GraphQL */ `
  fragment GetDeterminedAvailabilityFragment on Availability {
    state
  }
`);

export type GetDeterminedAvailabilityProps = FragmentType<typeof GetDeterminedAvailabilityFragment>;

export const getDeterminedAvailability = (data: GetDeterminedAvailabilityProps) => {
  const { state } = getFragmentData(GetDeterminedAvailabilityFragment, data);

  switch (state) {
    case 'AVAILABLE':
      return '1';
    case 'NOT_YET_AVAILABLE':
      return '0';
    case 'NOT_AVAILABLE':
      return '0';
    case 'UNSELECTED':
    default:
      return '2';
  }
};
